import { render, staticRenderFns } from "./TopEvents.vue?vue&type=template&id=974b917a"
import script from "./TopEvents.vue?vue&type=script&lang=js"
export * from "./TopEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports